export class DealPrintPreviewRequest {
    public dealID: number;
    public dealKey: string;
    public companyName: string;
    public serviceTypeID: number;
}


// WEBPACK FOOTER //
// ./src/app/_models/requests/deal-print-preview-request.model.ts